import React, { useState } from "react";
import image1 from "../../../assets/images/abdm3.svg";
import image2 from "../../../assets/images/nha.png";
import "./AadharAuth.css";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { resendAadharOtp, verifyAadharOtp } from "../../../api/abdm";
import useAppContext from "../../context/AppContext";

const initialState = {
  otp: new Array(6).fill(""),
};

const AadharAuth = () => {
  const { openSnackbar, abhaTxnId } = useAppContext();
  const location = useLocation();
  const navigate = useNavigate();

  const [otp, setOtp] = useState(initialState.otp);
  const [loading, setLoading] = useState(false);
  const [isOtpReSent, setIsOtpReSent] = useState(false);

  const aadhar = location.state?.aadhar;

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;
    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
    //Focus next input
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  async function verifyOtp() {
    setLoading(true);
    const OTP = otp?.join("");
    // console.log("AadharAuth", OTP);
    const response = await verifyAadharOtp(abhaTxnId, OTP);
    if (response?.status === 200) {
      openSnackbar({
        severity: "success",
        message: "OTP verified successfully",
      });
      navigate("/abha/aadharphonenumber", {
        state: { aadhaar: aadhar },
        replace: true,
      });
    } else {
      openSnackbar({
        severity: "error",
        message: response?.data?.message || "Could not verify OTP",
      });
    }
    setLoading(false);
  }

  async function onClickResendOtp() {
    if (isOtpReSent) {
      openSnackbar({
        severity: "error",
        message: "Cannot resend OTP",
      });
      return;
    }

    setLoading(true);
    setOtp(initialState.otp);
    // console.log("onClickResendOtp", abhaTxnId);
    const response = await resendAadharOtp(abhaTxnId);
    if (response?.status === 200) {
      openSnackbar({
        severity: "success",
        message: "OTP resend successfully",
      });
      setIsOtpReSent(true);
    } else {
      openSnackbar({
        severity: "error",
        message: response?.data?.message || "Could not resend OTP",
      });
    }
    setLoading(false);
  }

  async function onClickChangeAadhar() {
    navigate("/abha/registerabdm", { state: { aadhar } });
  }

  function onClickBack() {
    onClickChangeAadhar();
  }

  return (
    <div id="layout">
      <div className="abdm_header">
        <div className="abdm-back-logo" onClick={onClickBack}>
          <svg width="20" height="20" viewBox="0 0 30 30" fill="none">
            <path
              d="M11.9625 7.41211L4.375 14.9996L11.9625 22.5871M25.625 14.9996H4.5875"
              stroke="black"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div>
          <img src={image2} alt="nha" />
        </div>
        <div>
          <img src={image1} alt="abdm_image1" />
        </div>
        <h1>Unified Benefits</h1>
        <p>
          Link all healthcare benefits ranging from public health programmes to
          insurance schemes to your unique ABHA number
        </p>
      </div>
      <div className="abdm_content">
        <h1>Aadhaar Authentication</h1>
        <p>Enter the OTP sent on your Aadhar linked Phone Number.</p>
        <div className="d-flex justify-content-between">
          <p className="aadharNum">
            {aadhar} <br />
            <span className="otp_timer">
              <svg
                width="18"
                height="18"
                className="me-1"
                viewBox="0 0 18 18"
                fill="none">
                <rect width="18" height="18" fill="url(#pattern0)" />
                <defs>
                  <pattern
                    id="pattern0"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1">
                    <use
                      xlinkHref="#image0_5129_901"
                      transform="scale(0.0111111)"
                    />
                  </pattern>
                  <image
                    id="image0_5129_901"
                    width="90"
                    height="90"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAMFUlEQVR4nO2de4xcVR3Hv7+7s7vtbmX31mo7rYgmgASxQiQtNUgFAkJ4tLQwQISVteycO20tpSpUsHijPGpJF7JlmHtnKott5TG2tEIIbymP8I4piISHApHYB8hOwd3ug53784+Z6ro9Z+bcmTv7qPNJmibnd87vd+a3d849j9/5DVClSpUqVapUqVKlSpUqYxQa7Q7o4rpuAzPfTETfBzARQA+ATP7/vwF4m4jeIqJXm5qadkQikexo9nc4FXG067pfBjAbQC2AScxcD6ABQINhGPXMPCkvawJgADAB1DBzj2VZ5yh0OgCEZhf2EtFTnuc9UVtbu2XRokU7y/1M5RKqhNK6urpPBwYGbgRwOAAQ/ffvycyFmqZkhbZtGwBafHShmZnnEdG8wcHBW1zXfYyINvX19W1etmxZvw89gWFUQmlra+teZj4fwD5fnTGM+yvQnRoAZzDzpvr6+ncdx1mxYcOGxgrYKUhFHA0AlmW9SkSWjyb7uru7n5AJbNv2AGwIoFvTiWhtb2/v+8lk8grbtivyjZZRMUcDQDQa3QggoVOXiB5bsWJFr0re09NzJYDbAOwNoGtTmPnWcDj8suM4cwLQV5SKzjrS6XRdJpNpB7CkWF1mvtyyrN/o6HVdtzabzU6qq6s7hJnDzHwEgCMBzGbmOQAm+egmA7jVNM2VkUhkwEc7X1TM0fF4/NCampo0EZ2gUd0zDGN6W1vbnnLt2rYdmj59+ixmvgDABQBm6LQjopey2eyFsVjs/XL7INVfCaWu654O4HcApujUZ+YXLMsK/Cts27YRDofPZOYVRHSKRpMMM8+3LOvpoPsSuKOTyeRCZr4buXmyXieIrolGozcF3ZehOI5zvGEYNzPzd4tU7QNwsRBiW5D2A30ZJpPJi5j5HhR2sje8IJvNPhBkP2RYlvVKNBo9GcB5AD4oUHUCgM3JZPKyIO0H5mjHcS5h5k0ovAh6iJmPAvDXIWXvxmKx14PqRzGEENvq6upmAthUoFoNM693XXd+UHYDcXQqlfoOEd2B3OJAxmcAfhKNRs+yLOsdwzAWIr+YYeaKP83DaW1t3SuEuJSZfwhANdOoAXC34zgnBWGzbEfH4/FDPc/bDPVwsY+I5gkh1hIRA0BbW9trzCwAoKamphKrQS0sy+oEcCqAfyqqTCCibYlE4ivl2irL0e3t7RNDodBWAF9UVMkQ0WnRaPSh4QLLsjYBuNHzvGf82MzvewSGEOJZAKcA+EhRxTQM4x7XdbVf7jLKmnW4rrsOwFKFuJuZT7Ys65VybOynvb19YmNj480ALskXbezp6bmq0GrSD4lE4hjDMJ6EYkpKRO3RaPTHpeov+elIJBKzAMQU4kEAFwXlZABoaGi4CbkVZlP+39LGxsYbgtIfi8VeNwxjARRjNjMvT6VSOosvKSU52rbtkGEYDtQvv+VCiAdL7ZQMIrpIUnxxkDba2tqeISLVw2N4nnd7Op1WfeaClOTocDj8IwDHKcT3CyHipegtwlRJ2bSgjUSj0TsA3KUQH9fV1bW4FL2+He26bgOAaxTijwYHB3VPQcYyiwH8XSYgouvi8bifTSsAJTiaiNqgeGEw8xVLlizZ7VfnWEMI8QkRLVeIp4RCocv96vTlaNd1a5n5SoX4ZSHEPX47MFaJRqNbATyuEF/V2dk5wY8+X45m5osBHCaTeZ531f4FycECM/9MIQr39/ef50eXL0cTkfSAlIi2x2Kx7X50jQfy09MnZTIiutSPLm1Hu647BcBcmczzPMeP0XHGWkX5afF4XHvWo+1oIjoX8p25DydPnrxVV894Y9euXQ8BkMWFhEKh0EJdPX6GDpXSuyp51jba5E/g0zIZM5+qq0fL0el0uoaZpcMGET2sa2y8QkS/V5TP1d3k0qqUyWSOACALOunt7u4O/HxtrMHMLwPologmh8PhY3V0aDmamaXLbSJ6Nqjds7GMEOIzInpeJiOimTo6tBxNRKp9jT/rtD9IeFFWyMxf02ms6+ivK4y8pdP+IOFtWWGgjmbmzyvK39RpfzBARO8oyr+q0143yK9JYeTeZDL52+bm5usO1ilePqztes/zVCtBqW+Go+voZkX5NGa+OpPJMADVvkDZOI5zdKV0FyOTyVwP4KcFqnxOR4/ugsUsIg802GQojuO0ENFLldKvQbE9DS1H6z7RxQ5xD4g+KpcNGzY07tu37zYiKvRH/DhouxIC2ZHUfaL/VUQeRJD4f3Ac5+je3t6Xijg5cLsKNhaRF/MNgPIdvRvAatM0f6GppyjJZPKy/FBRbFzuNE1zZVB2VZimuQrAGuQ+qwwtR+sOHZ8qyucLIaQTeb/sHyqYudhT3ENES6PR6J1B2C1GfjZ1dSqV2up5nmx1+ImOHt0Fy3uK8sN12hfDdd2jent7n9cYKt4EMGeknDyU/K0CGe/qtNddsEhXgJ7nHanTvhD58NhXAHyjSB/unDhx4vFCiFFZ9hdYAUpXjMPRGjqI6C3F/cDZOu1l2LYdCofDSWZuLVK1h4iWCiFG/CkehvSzEpHWNoTu0PGqonxOqZE74XD4BgDFnPwGM88ajaFiKPlrctJwsGw2K/XNcLQc3dTUtAPya2eHdHV1zdLRIaHgeJwfKmZZlvVGifoDIxwOnwD5Ta+uPXv2BOfoSCSSJaKnZDIi0j43G4ZqIdBDRK2WZbW2tLT0lKg7UPK3gGVszx91FUX7zNDzPOmtVgDnlxiz3CkpGxNDxVDS6XRNgYdJFWBzANoOqq2t3QJAlprhsHA4fKaunv2YpvlzAKuRO2HeA2DNWBkqhtLV1XU2gC9JRIOGYdynq8dXILrjOA8T0feGlzPzI5ZlneFH13jBcZwnFHcUHxRCnK2rx9dX3jAM6bqfiE4vJ0h7rJJIJGYR0ckyGTMX2wP5H3w5uq+vbzOAf0hE5Hneaj+6xgOGYayG/Fu/q76+/g++dPmpvGzZsn5mbleI5zqOI80eMx5xHGcBAOnTTES/bm1t7fOjz/dsoaGhwYXiBhMRuZ2dnarTmHGD67pNRNShEO9hZmmmnEL4dnRLS0sPEaku6YT7+/tv8atzDLIO6qwIvxJC+MqsA5R4h6W5ufk2ADtkMiK6zHVd3xHxYwXHcSyoj6/+ZJpmSZGzJTk6EolkmXkx1Ku7dclk8tul6B5NXNc9kYhuVYg9z/NipaZ5K/meoWVZzwNQdWoCMz+QSCSOKVX/SJNKpWYCeABAvaLK2lgsVvIhcVnXfU3TXFnghHqyYRiPjgdnp1KpmZ7nPQJ1WMVzAK4tx0ZZjo5EIgPZbPZC5DIqyggbhvH0WB5GXNc90fO8p6C+s/gxcolSPivHTtkX2GOx2PvMfBbUOe5MZv5jMpm8olxbQeM4TguAR6F+knsNwzhPCCG9c+iHwFL95JOIbIb62jKY+U4iWi6E0DrQrBSdnZ3NAwMDHSgcHJMlogXRaDSQNBeBpWQQQmwjossh3+EDkJv6AfiL4zjzgrLrF8dxFgwMDLyBwk4eBLAoKCcDlUledW4+r9LEIlWfMwxjZVtbm698HaWSSCRm5fcupMvqIfQz8yWWZW0O0n5F0rE5jnMSEW1D8Zg9JqLHPc9bt3v37gcLnVbsj+rEkHwdpmmuKhTFatu2MW3atHOIaClymWaKfd6PkYtVebZIPd9ULMHg+vXrD8tms/dC/6T8AwBbAGzZtWvXC7ZtDw4Vuq67BgdGda4RQlw9tMC27dCMGTPmZLPZhfmTEdmmvYznkJtdlP3ik1HRlJmu69YS0WpmXg5/74NuAC8AeJGZ38wHgW/DgVOw3QDmE9GR+biL2cidVvvJPuAhd2nz2nKncIUYkYzoqVTqW8x8OzOXemJeKXYw8+L8KreijFjq+XQ6XdPV1bWYiFYB+MJI2VXwIYBfmqbpjFSK+hHP8d/R0VFfX1//AwCroD9+BsUeZr6FiNaVstVZDqP2YwodHR31dXV1C/JZAk5HgYVOmQwS0aMANvb19W0drdTzY+JXK+Lx+LRQKLSQmU8lorkAJpepsgvAdgCPG4ZxXxDpkstlTDh6KLZtG1OnTv0mER27fzaRv2J2CHJ7EvtnFN3Ihal9AuA95H8eBMCOnTt3vqYbQVSlSpUqVapUqVKlSpUq//f8G79pLhcrYj5IAAAAAElFTkSuQmCC"
                  />
                </defs>
              </svg>
              30s{" "}
              <span
                onClick={onClickResendOtp}
                className={isOtpReSent ? "otp_timer" : "resend_cta"}>
                Resend OTP
              </span>
            </span>
          </p>
          <p onClick={onClickChangeAadhar} className="change_aadhar__num">
            Change Aadhar
          </p>
        </div>
        <div className="otp_box">
          {otp.map((data, index) => {
            return (
              <input
                className="otp-field"
                type="text"
                name="otp"
                maxLength="1"
                key={index}
                value={data}
                onChange={(e) => handleChange(e.target, index)}
              />
            );
          })}
        </div>
        <button onClick={verifyOtp} disabled={loading}>
          {loading ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <CircularProgress sx={{ color: "white" }} size="1.25rem" />
            </div>
          ) : (
            "Verify"
          )}
        </button>
      </div>
    </div>
  );
};

export default AadharAuth;
